import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Modal } from '../Modal/Modal';
import { Button } from '../Button/Button';

export function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirmer',
  description,
  confirmLabel = 'Confirmer',
  cancelLabel = 'Annuler',
  variant = 'danger', // 'danger' | 'primary'
  isLoading = false,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      hideCloseButton
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>{cancelLabel}</Button>
          <Button variant={variant} onClick={onConfirm} isLoading={isLoading}>{confirmLabel}</Button>
        </>
      }
    >
      <div className="flex items-start gap-3">
        {variant === 'danger' && (
          <div className="shrink-0 w-9 h-9 rounded-full bg-danger-bg text-danger flex items-center justify-center">
            <AlertTriangle className="w-4 h-4" strokeWidth={2} />
          </div>
        )}
        <div className="leading-tight">
          <div className="text-base font-bold tracking-tight">{title}</div>
          {description && <p className="text-sm text-mute mt-1 leading-relaxed">{description}</p>}
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmDialog;
